import i18next from 'i18next';

const format = (amount: number): string => {
  return i18next.t('currency:defaultFormat', { amount });
};

export default { format };
